import { useState, useCallback, useMemo } from 'react';

import { Journey } from './useItineraryViews';

export enum Direction {
  'OUTBOUND' = 'outward',
  'INBOUND' = 'inward',
}

const useJourneyDirection = (journeys: Journey[]) => {
  const [journeyDirection, setJourneyDirection] = useState(Direction.OUTBOUND);

  const handleDirectionChange = useCallback((direction: Direction) => {
    setJourneyDirection(direction);
  }, []);

  const hasInbound = useMemo(() => journeys.length > 1, [journeys.length]);
  const selectedJourney = useMemo(
    () =>
      journeys.find((journey) => journey.direction.toLowerCase() === journeyDirection) ||
      journeys[0],
    [journeys, journeyDirection]
  );

  return {
    journeyDirection,
    hasInbound,
    selectedJourney,
    handleDirectionChange,
  };
};

export default useJourneyDirection;
